import React, { useState } from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PharmacyTable from './PharmacyTable';
import PharmacyModal from './PharmacyModal';
import CommonBreadCrumb from 'components/commonbreadcrumb/CommonBreadCrumb';
import paths from 'routes/paths';

const Pharmacy = () => {
    const [trigger, setTrigger] = useState(0);
    const [edittrigger, setEditTrigger] = useState(0);
    const [pharmacyval, setPharmacyVal] = useState('');
    const [showModal, setShowModal] = useState(false);

    const callAnotherChildMethod = () => {
        setTrigger((trigger) => trigger + 1);
    };

    const callAnotherEditChildMethod = (editValue) => {
        setPharmacyVal(editValue);
        setEditTrigger((edittrigger) => edittrigger + 1);
        setShowModal(true);
    };

    const handleOpenAddModal = () => {
        setPharmacyVal('');
        setEditTrigger(0);
        setShowModal(true);
    };

    const breadcrumbItems = [
        { name: 'Dashboard', href: '/main', isActive: false },
        { name: 'Drugs-Pharmacy', href: paths.pharmacy, isActive: true }
    ];

    return (
        <>
            <CommonBreadCrumb breadcrumbItems={breadcrumbItems} />
            <Row className="g-3 mt-1">
                <Col xs={12}>
                    <Card>
                        <Card.Header className="bg-body-tertiary py-2">
                            <h5 className="mb-0">Pharmacy</h5>
                        </Card.Header>
                        <Card.Body>
                            <PharmacyTable
                                trigger={trigger}
                                onCallEditParent={callAnotherEditChildMethod}
                                onOpenAddModal={handleOpenAddModal}
                            />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <PharmacyModal
                show={showModal}
                onHide={() => setShowModal(false)}
                pharmacyid={pharmacyval}
                edittrigger={edittrigger}
                onCallParent={callAnotherChildMethod}
            />
        </>
    );
};

export default Pharmacy;

